module.exports = __webpack_public_path__ + "img/new bg.25a4afbf.png";